import Vue from 'vue'
import App from './App.vue'
import MultiCarousel from './components/MultiCarousel.vue'
import router from './router'

Vue.config.productionTip = false
Vue.component('MultiCarousel', MultiCarousel)

const app = new Vue({
  router,
  render: h => h(App)
})

// 让 router 先去下载页面文件、解析路由，等 completely ready 了，再挂载显示网页
router.onReady(() => {
  app.$mount('#app')
})